import React from 'react';
import { User, Users } from 'lucide-react';

export type DashboardTab = 'my-feedback' | 'team-feedback';

interface DashboardTabsProps {
  activeTab: DashboardTab;
  onTabChange: (tab: DashboardTab) => void;
  myFeedbackCount: number | null;
  myFeedbackLoading?: boolean;
  teamFeedbackCount: number;
  teamFeedbackLoading?: boolean;
  hasDirectReports: boolean;
}

export function DashboardTabs({
  activeTab,
  onTabChange,
  myFeedbackCount,
  myFeedbackLoading,
  teamFeedbackCount,
  teamFeedbackLoading,
  hasDirectReports
}: DashboardTabsProps) {
  return (
    <div className="flex items-center gap-3 mb-6">
      <button
        onClick={() => onTabChange('my-feedback')}
        className={`
          flex items-center gap-2 px-6 py-3 rounded-xl font-semibold transition-all duration-200
          ${activeTab === 'my-feedback'
            ? 'bg-white text-pink-600 border border-pink-300 border-b-[3px] border-b-pink-500 shadow-sm'
            : 'bg-white text-slate-500 hover:bg-slate-50 border border-slate-200 hover:border-slate-300'
          }
        `}
      >
        <User className="w-4 h-4" />
        <span>My Connect</span>
        <span className={`
          ml-1 px-2 py-0.5 rounded-full text-xs font-bold
          ${activeTab === 'my-feedback'
            ? 'bg-pink-100 text-pink-600'
            : 'bg-slate-100 text-slate-500'
          }
        `}>
          {myFeedbackLoading ? '…' : (myFeedbackCount ?? 0)}
        </span>
      </button>

      {hasDirectReports && (
        <button
          onClick={() => onTabChange('team-feedback')}
          className={`
            flex items-center gap-2 px-6 py-3 rounded-xl font-semibold transition-all duration-200
            ${activeTab === 'team-feedback'
              ? 'bg-white text-pink-600 border border-pink-300 border-b-[3px] border-b-pink-500 shadow-sm'
              : 'bg-white text-slate-500 hover:bg-slate-50 border border-slate-200 hover:border-slate-300'
            }
          `}
        >
          <Users className="w-4 h-4" />
          <span>Team Connect</span>
          <span className={`
            ml-1 px-2 py-0.5 rounded-full text-xs font-bold
            ${activeTab === 'team-feedback'
              ? 'bg-pink-100 text-pink-600'
              : 'bg-slate-100 text-slate-500'
            }
          `}>
            {teamFeedbackLoading ? '…' : teamFeedbackCount}
          </span>
        </button>
      )}
    </div>
  );
}
